import { BaseController } from '../../../../../common/base/controller';
import { prepareAccountModelAdapter } from '../../../../../common/adapter/randomDataAccountAdapter';
import _ from 'lodash';

import { homeStateName } from '../../../../../components/home/home.state';

import { DATA_GENERATOR_CONFIG } from './dataGenerator';

export class ConfirmWarrantController extends BaseController {
  constructor(
    controllerService,
    ticketService,
    transferringService,
    transferringConfirmWarrantService,
    fdFormFieldsService,
    $scope,
    hotkeys,
    TicketStates,
    TransferringConfirmSuccessState,
    SepaCountries,
    transferringListStateName,
    ticketSidebarPartial,
    ticketClosePartial,
    transferringConfirmPendingPartial,
    dataParser,
    dataGenerator,
  ) {
    'ngInject';
    super({
      controllerService,
      ticketService,
      transferringService,
      transferringConfirmWarrantService,
      fdFormFieldsService,
      $scope,
      hotkeys,
      TicketStates,
      TransferringConfirmSuccessState,
      SepaCountries,
      ticketSidebarPartial,
      ticketClosePartial,
      transferringListStateName,
      transferringConfirmPendingPartial,
      dataParser,
      dataGenerator,
    });
  }

  get ticketId() {
    return this.$stateParams.ticketId || this.ticket.id;
  }

  get form() {
    return this.confirmWarrantForm;
  }

  set form(value) {
    this.confirmWarrantForm = value;
  }

  get isNotProduction() {
    return !this.envService.isProduction();
  }

  $onInit() {
    // Check access for the given user
    if (!this.isStateAccessible()) {
      this.viewStatus = 'pending';
    }

    this.hideUserSectionInSidebar = true;

    // Assign
    const { SepaCountries } = this;
    this.model = {};
    this.isLayoutResizeable = false;
    this.breadcrumbs = this.transferringService.states;
    this.signedWarrantUrl = this.ticketService.getSignedWarrantUrl(
      this.ticketId,
    );
    this.fieldOptions = { filterCountries: SepaCountries.list };

    // Trigger
    this.bindHotkeys();
    this.$timeout(() => {
      this.setupFormRuler();
    });

    let customer = this.$stateParams.customer || {};
    if (customer.newIban || customer.oldIban) {
      this.model.newIban = customer.newIban;
      this.model.oldIban = customer.oldIban;
    }

    this.ticketService.registerForChange(
      this.ticketChanged.bind(this),
      this.ticket.id,
    );
  }

  ticketChanged(type, ticket) {
    this.ticket = ticket;
  }

  /**
   * This state is only accessible for users with the following permissions:
   * - Transferring.Create
   * - Transferring.Handle
   */
  isStateAccessible() {
    let { Permissions } = this.userService;
    let { Create, Handle } = Permissions.transferring;
    return this.userService.hasPermission([Create, Handle]);
  }

  submit() {
    const { ticketId } = this;
    let model = this.prepareModelBeforeValidation(this.model);

    this.fdFormFieldsService.validate(this.confirmWarrantForm).then(() => {
      const params = this.prepareModelAfterValidation(model);
      this.submitBusy = true;
      this.ticketService.confirmOutgoing(ticketId, params).then(() => {
        this.submitBusy = false;
        this.go(this.TransferringConfirmSuccessState, { ticketId });
      });
    });
  }

  prepareModelBeforeValidation(model) {
    let modelPrepared = this.dataParser.unflatten(model);

    if (modelPrepared.additionalAccountOwners) {
      modelPrepared.additionalAccountOwners.map((owner) => {
        for (let i in owner) {
          if (/\d+$/.test(i)) {
            owner[i.replace(/\d+$/, '')] = owner[i];
          }
        }
      });
    }

    return modelPrepared;
  }

  setupFormRuler() {
    const {
      $scope,
      $compile,
      $document,
      transferringConfirmWarrantService,
      model,
      form,
    } = this;
    const injections = { $scope, $compile, $document };

    // Bind rules for the form
    const formRules = transferringConfirmWarrantService.getFormRules();

    // Watch every model value which has a defined form rule
    _.forEach(formRules, (rule, key) => {
      $scope.$watch(
        `vm.model.${key}`,
        rule.create(form, model, key, injections),
      );
    });
  }

  demo() {
    this.fillRandomData();
  }

  closeRequest() {
    const { id, requestType } = this.ticket;
    this.ticketService.closeTicket(requestType, id).then((r) => {
      this.go(homeStateName);
    });
  }

  releaseTicketOverSidebar() {
    const { id, requestType } = this.ticket;
    return this.ticketService.releaseTicket(requestType, id).then(() => {
      this.go(homeStateName);
    });
  }

  prepareModelAfterValidation(model) {
    const params = angular.copy(model);
    if (!params.replyFaxNumberExpandable) {
      delete params.replyFaxNumber;
    }
    return prepareAccountModelAdapter(params);
  }

  // Used by the transferringConfirmPendingPartial
  // to navigate back to the ticket list.
  navigateTo() {
    this.go(this.transferringListStateName);
  }

  toggleResizeable() {
    this.isLayoutResizeable = !this.isLayoutResizeable;
  }

  bindHotkeys() {
    const { hotkeys, $scope } = this;

    // Bind Hotkeys to the controllers scope (will automatically unbind
    // the hotkey when the scope is destroyed)
    const keyBinding = hotkeys.bindTo($scope).add({
      combo: 'ctrl+l',
      description: 'Toggle dev mode',
      callback: () => this.toggleDevMode(),
    });

    if (!this.envService.isProduction()) {
      keyBinding.add({
        combo: 'return+return',
        description: 'Submit form',
        callback: () => this.submit(),
      });
    }
  }

  fillRandomData() {
    if (this.envService.isProduction()) {
      return;
    }

    this.model.isDemoData = true;

    _.map(DATA_GENERATOR_CONFIG, (field) => {
      const generated = this.dataGenerator.generate(field);
      this.model[field.name] = generated;
    });
  }
}
